export default "/images/vendor/flag-icon-css/flags/1x1/pn.svg?353f8e647a29592d02b34a69f426b1c6";